import { clsx } from 'clsx';
import { type ReactNode } from 'react';

import styles from './CardLayout.css';

type TCardLayoutProps = {
  gallery: JSX.Element;
  content: JSX.Element;
  publisher: JSX.Element;
  isTop?: boolean;
  onClick: VoidFunction;
  onMouseEnter?: VoidFunction;
  onMouseLeave?: VoidFunction;
} & { [key: `data-${string}`]: string };

export function CardLayout({
  publisher,
  content,
  gallery,
  isTop,
  onClick,
  onMouseEnter,
  onMouseLeave,
  ...dataAttrs
}: TCardLayoutProps): ReactNode {
  return (
    <article
      className={clsx(styles['card-layout'], isTop && styles['card-layout_top'])}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...dataAttrs}
    >
      <div className={styles['card']}>
        <div className={styles['card__gallery']}>{gallery}</div>
        <div className={styles['card__content']}>{content}</div>
        <div className={styles['card__publisher']}>{publisher}</div>
      </div>
    </article>
  );
}
